export default __webpack_public_path__ + "static/media/right_header.59ea4884.svg";